import { useEffect, useState } from 'react';

const BuyerPoolLoader = () => {
    const [pulseCount, setPulseCount] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setPulseCount((prev) => (prev + 1) % 3);
        }, 600);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="w-full h-full flex items-center justify-center bg-white bg-opacity-50 backdrop-blur-sm min-h-[400px]">
            <div className="flex flex-col items-center justify-center gap-6 p-8 rounded-xl bg-white/80 shadow-lg border border-gray-100 max-w-sm mx-auto">
                {/* Animated Dots */}
                <div className="flex items-center gap-2">
                    {[0, 1, 2].map((index) => (
                        <div
                            key={index}
                            className={`w-3 h-3 rounded-full transition-all duration-300 ease-in-out ${
                                index === pulseCount ? 'bg-my-blue scale-125 shadow-lg shadow-my-blue/30' : 'bg-gray-300 scale-100'
                            }`}
                            style={{
                                animationDelay: `${index * 200}ms`,
                            }}
                        />
                    ))}
                </div>

                {/* Loading Text */}
                <div className="text-center">
                    <div className="text-my-blue text-lg font-medium mb-1">Loading search requests...</div>
                    <div className="text-gray-500 text-sm">Fetching requests from other users</div>
                </div>

                {/* Subtle Progress Indicator */}
                <div className="w-32 h-0.5 bg-gray-200 rounded-full overflow-hidden">
                    <div
                        className="h-full bg-gradient-to-r from-my-blue to-blue-400 rounded-full transition-all duration-500 ease-out"
                        style={{
                            width: `${((pulseCount + 1) / 3) * 100}%`,
                            boxShadow: '0 0 8px rgba(49, 118, 188, 0.2)',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default BuyerPoolLoader;
